import React, { useState } from 'react';
import FormGroupTextArea from "../formGroupTextArea";
import FormGroupSelectInput from "../formGroupSelectInput";
import _ from 'lodash';
import FormGroupTextInput from "../formGroupTextInput";
import FormGroupDateInput from "../General/formGroupDateInput";
import FormGroupTable from "../formGroupTable";
import {FormGroup} from 'arag-ui-lib';
import {
    flattenQuestions,
    getDateQuestionMaximumValue,
    getDateQuestionMinimumValue,
    getOpponentQuestionValue
} from "../../helpers/questions/functions";
import {
    CURRENCY, CURRENCY_CODE, CURRENCY_MENU_OPTIONS
} from "../../helpers/variables";
import FormGroupFileInput from "../formGroupFileInput";

const AnsweredQuestion = (props) => {
    const {isPlain,attachments, onAttachmentRequest} = props;
    const [questionValidation, setQuestionValidation] = useState({})

    const validateAmountTypeQuestion = (questionId,value) => {
        var errMsg = '';
        let s = value.toString().split(/\.|,/);
        if (isNaN(value) && value !== "") errMsg = 'Input is not a valid number';
    
        setQuestionValidation({...questionValidation,[questionId]:errMsg});
    }


    //upload question
    if (props.question.inputType === 'upload') {
        return (
            <FormGroupFileInput
                onAttachmentRequest={onAttachmentRequest}
                attachments={attachments && attachments.filter(a => a.questionId === props.question.id) }
                isPlain={isPlain}
                multiple={props.multipleFilesAllowed}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                DropzoneStyle="formGroup-textInput-input newApplication-upload-element"
                Label={props.question.name}
                Required={props.question.isRequired}
                Name={props.question.id}
                key={props.question.id}
                OnDrop={(files) => props.onDrop(files, props.question.id)}/>
        );
    }
    let opponentAnsweredQuestionMachineNames = [];
    let renderOpponentContent = null;

    // opponent question?
    if(props.question.machineName === "OpponentName") {
        opponentAnsweredQuestionMachineNames.push(props.question.machineName);
        renderOpponentContent = (

            <div>
                <FormGroupTextInput
                    isPlain={isPlain}
                    InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                    Label={props.question.name}
                    Required={props.question.isRequired}
                    Name={props.question.id}
                    key={props.question.id}
                    Type="text" Value={props.opponent.name}
                    HandleInputChange={(key, value) => props._handleChangeOpponent(
                        props.question.machineName,
                        value
                    )}
                />
                {
                    props.question.options.map( option => {

                        return option.childQuestions.map (childQuestion => {
                            const selectedOption = _.find(childQuestion.options, c => {
                                return c.id.toString() === getOpponentQuestionValue(childQuestion.machineName, props.opponent)
                            });
                            opponentAnsweredQuestionMachineNames.push(childQuestion.machineName);
                            return (

                                <div>
                                    <FormGroupSelectInput
                                        isPlain={isPlain}
                                        Label={childQuestion.name}
                                        LeftWrapper="col-sm-3"
                                        Required={childQuestion.isRequired}
                                        Name={childQuestion.id}
                                        Value={getOpponentQuestionValue(childQuestion.machineName, props.opponent)}
                                        plainValue={selectedOption? selectedOption.name : ""}
                                        key={childQuestion.id}
                                        Options={[{key: '', value: ''}, ...childQuestion.options.map(o => ({key: o.id, value: o.name}))]}
                                        HandleInputChange={(evt) => props._handleChangeOpponent(
                                            childQuestion.machineName,
                                            evt.target.value
                                        )}
                                        CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                                        RightWrapper=""
                                        SelectStyle={'form-control formGroupSelectInput-select'}
                                    />

                                    {
                                        selectedOption && (
                                            selectedOption.childQuestions.map (cq => {
                                                const selectedOption = _.find(cq.options, c => {
                                                    return c.id.toString() === getOpponentQuestionValue(cq.machineName, props.opponent)
                                                });
                                                opponentAnsweredQuestionMachineNames.push(cq.machineName);
                                                return (<div key={cq.id}>
                                                    <FormGroupSelectInput
                                                        isPlain={isPlain}
                                                        Label={cq.name}
                                                        LeftWrapper="col-sm-3"
                                                        Required={cq.isRequired}
                                                        Name={cq.id}
                                                        Value={getOpponentQuestionValue(cq.machineName, props.opponent)}
                                                        plainValue={selectedOption ? selectedOption.name : ""}
                                                        key={cq.id}
                                                        Options={[{key: '', value: ''}, ...cq.options.map(o => ({key: o.id, value: o.name}))]}
                                                        HandleInputChange={(evt) => props._handleChangeOpponent(
                                                            cq.machineName,
                                                            evt.target.value
                                                        )}
                                                        CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                                                        RightWrapper=""
                                                        SelectStyle={'form-control formGroupSelectInput-select'}
                                                    />                                                   
                                                
                                                {
                                                    cq.options.map(grandchildChildQuestionOption => {
                                                        if (grandchildChildQuestionOption.id.toString() === props.opponent["insurerOptionId"] && (grandchildChildQuestionOption.childQuestions.length > 0)) {
                                                            return <div key={grandchildChildQuestionOption.id}>
                                                                {
                                                                    grandchildChildQuestionOption.childQuestions.map(grandchildChildQuestion => {
                                                                            opponentAnsweredQuestionMachineNames.push(grandchildChildQuestion.machineName);
                                                                                return <div key={grandchildChildQuestion.id}>
                                                                                    <FormGroupTextInput
                                                                                        isPlain={isPlain}
                                                                                        autoComplete={'off'}
                                                                                        Label={grandchildChildQuestion.name}
                                                                                        Required={grandchildChildQuestion.isRequired}
                                                                                        Name="otherInsurerName"
                                                                                        Type="text"
                                                                                        Value={props.opponent.otherInsurerName}
                                                                                        key={grandchildChildQuestion.id}
                                                                                        InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                                                                                        HandleInputChange={(key, value) => props._handleChangeOpponent(
                                                                                            grandchildChildQuestion.machineName,
                                                                                            value 
                                                                                        )}                                                                                    />
                                                                                </div>
                                                                            })}
                                                                    </div>
                                                                }
                                                            })
                                                }</div>)

                                            })
                                        )
                                    }
                                </div>
                            )

                        });

                    })
                }
            </div>

        );
        props.addOpponentAnsweredQuestionMachineNames(opponentAnsweredQuestionMachineNames);
        return (
            <div>
                {renderOpponentContent}
            </div>)
    }


    //table question
    if(props.question.inputType === "table") {
        return (
            <FormGroupTable
                smallHeader={props.smallHeader}
                plain={isPlain}
                LeftWrapper="col-sm-9"
                rightWrapper="col-sm-3"
                key={props.question.id}
                Label={props.question.name}
                medicalExpertFees={props.medicalExpertFees}
                updateMedicalExpertFees={props._updateMedicalExpertFees}
                removeMedicalExpertFeesTableRow={props._removeMedicalExpertFee}
                breachCausationCp={props.breachCausationCp}
            />

        )
    }


    //calendar question?
    if(props.question.inputType === 'calendar'){
        let value =  props.questionAnswer;
        let maxDate , minDate ;
        try {
            // date field
            if(props.application){
                const flattened = flattenQuestions(props.application.questionsDtos);
                minDate = getDateQuestionMinimumValue(props.question, props.formData, flattened);
                maxDate = getDateQuestionMaximumValue(props.question, props.formData, flattened);
            }
        } catch (e) {
        }
        return (
            <FormGroupDateInput
                autoComplete={'off'}
                isPlain={isPlain}
                centerClassName="col-sm-6"
                leftClassName="col-sm-3"
                label={props.question.name}
                required={true}
                name={props.question.id}
                Key={props.question.id}
                type="text"
                value={value}
                min={minDate}
                max={maxDate}
                handleInputChange={props._handleDateInputChange}/>
        )
    }

    //text question?
    if(props.question.inputType === 'text'){
        return (
            <FormGroupTextInput
                isPlain={isPlain}
                InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                Label={props.question.name}
                Required={props.question.isRequired}
                Name={props.question.id}
                key={props.question.id}
                Type="text" Value={props.questionAnswer}
                HandleInputChange={props._handleTextInputChange}
            />
        )
    }

    if(props.question.inputType === 'amount'){
        return (
                <FormGroup
                    errorMessage={questionValidation[props.question.id]}
                    labelSize="col-sm-3"
                    inputSize="col-sm-6"
                    label={<p style={{ fontSize: '14px' }}>{props.question.name}</p>}
                    variant={isPlain ? "plain" : "currency"}
                    inputProps={{
                        value: props.questionAnswer,
                        key: props.question.id,
                        onBlur: () => validateAmountTypeQuestion( props.question.id,props.questionAnswer),
                        name: `${props.question.id}`,
                        onChange: (e) => {
                            props._handleTextInputChange(e.target.name, e.target.value);
                            validateAmountTypeQuestion(e.target.name,e.target.value,null);
                        },
                        label:isPlain ? props.questionAnswer : '',
                        disabledDropdown: true,
                        handleOptionSelect: () => { },
                        menuOptions: CURRENCY_MENU_OPTIONS,
                        selectedCurrency: { sign: `${CURRENCY}`, code: `${CURRENCY_CODE}` },
                        required: props.question.isRequired 
                    }}
                />
        )
    }

    //text area question?
    if(props.question.inputType === 'text area'){
        return (
            <FormGroupTextArea
                isPlain={isPlain}
                rows={6}
                centerWrapper="col-sm-6 formGroupTextArea-wrapper"
                required={props.question.isRequired}
                Label={props.question.name}
                Name={props.question.id}
                key={props.question.id}
                Value={props.questionAnswer}
                HandleInputChange={props._handleTextInputChange}
            />
        )
    }

    //drop down question?
    if(props.question.inputType === 'drop down'){
        let selectedOption;
        if(!props.question.isStandard || props.question.machineName === "workSourceId"){
            selectedOption = _.find(props.question.options, o => {return (
                o.id
                && props.questionAnswer
                && o.id.toString() === props.questionAnswer.toString()
            )})
        }
        return (
            <div>
                <FormGroupSelectInput
                    isPlain={isPlain}
                    Label={props.question.name}
                    LeftWrapper="col-sm-3"
                    Required={props.question.isRequired}
                    Name={props.question.id}
                    Value={props.questionAnswer}
                    plainValue={selectedOption ? selectedOption.name: ""}
                    key={props.question.id}
                    Options={[{key: '', value: ''}, ...props.question.options.map(o => ({key: o.id, value: o.name}))]}
                    HandleInputChange={props._handleSelectInputChange}
                    CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                    RightWrFapper=""
                    SelectStyle={'form-control formGroupSelectInput-select'}
                />
                {
                    (selectedOption && selectedOption.childQuestions) && (
                        <div>
                            {
                                selectedOption.childQuestions.map (childQuestion => {
                                    return (
                                        <AnsweredQuestion
                                            application={props.application}
                                            onAttachmentRequest={onAttachmentRequest}
                                            attachments={attachments}
                                            multipleFilesAllowed={props.multipleFilesAllowed}
                                            isPlain={isPlain}
                                            key={childQuestion.id}
                                            formData={props.formData}
                                            opponent={props.opponent}
                                            question={childQuestion}
                                            questionAnswer={props.formData[childQuestion.id]}
                                            medicalExpertFees={props.medicalExpertFees}
                                            breachCausationCp={props.breachCausationCp}
                                            _removeMedicalExpertFee={props._removeMedicalExpertFee}
                                            _addMedicalExpertFee={props._addMedicalExpertFee}
                                            _updateMedicalExpertFees={props._updateMedicalExpertFees}
                                            _handleChangeOpponent={props._handleChangeOpponent}
                                            _handleTextInputChange={props._handleTextInputChange}
                                            _handleSelectInputChange={props._handleSelectInputChange}
                                            _handleDateInputChange={props._handleDateInputChange}
                                            onDrop={props.onDrop}
                                        />
                                    )
                                })
                            }
                        </div>
                    )
                }
            </div>
        )
    }
    //TODO: this is a temporary fix to a bug introduced on December 2023
    if(props.addOpponentAnsweredQuestionMachineNames) {
        props.addOpponentAnsweredQuestionMachineNames(opponentAnsweredQuestionMachineNames);
    }
    return null
};

export default AnsweredQuestion;